<div class="d-flex flex-column flex-column-fluid">
  <div id="kt_app_content" class="app-content flex-column-fluid">
    <div id="kt_app_content_container" class="app-container container-fluid">
      <div class="card mb-5 mb-xl-8">
        <div class="card-header border-0 pt-5">
          <h3 class="card-title align-items-start flex-column">
            <span class="card-label fw-bold fs-3 mb-1">{{
              "surveyManagements" | translate
            }}</span>
          </h3>
        </div>
        <div class="card-body pt-3 pb-6">
          <div class="d-flex align-items-center justify-content-between mb-6">
            <!-- Filters -->
            <div
              class="btn-group"
              role="group"
              aria-label="Basic radio toggle button group"
            >
              <div *ngFor="let application of applications; let i = index">
                <input
                  type="radio"
                  class="btn-check"
                  name="btnradio"
                  id="btnradio{{ i }}"
                  autocomplete="off"
                  [checked]="application.code === selectedApplicationCode"
                />
                <label
                  (click)="selectApplicationFilter(application.code)"
                  class="btn btn-sm btn-outline-dark cursor-pointer"
                  for="btnradio{{ i }}"
                  >{{ application.title }}</label
                >
              </div>
            </div>

            <!-- Create new survey btn -->
            <div class="d-flex justify-content-end mb-6">
              <a
                [routerLink]="['/survey/create', selectedApplicationCode]"
                style="margin-left: 30px"
                class="btn btn-sm fw-bold btn-primary"
                >{{ "createNewSurvey" | translate }}</a
              >
            </div>
          </div>

          <div
            *ngIf="surveyListLoading; else surveyList"
            class="d-flex justify-content-center pb-4"
          >
            <div class="spinner-border text-danger" role="status">
              <span class="visually-hidden">surveyListLoading...</span>
            </div>
          </div>
          <ng-template #surveyList>
            <!-- Survey List -->
            <div
              *ngIf="surveys?.length; else noSurvey"
              class="accordion shadow-sm"
              id="accordionExample"
            >
              <div
                *ngFor="let survey of surveys; let i = index"
                class="accordion-item"
              >
                <h2 class="accordion-header cursor-pointer">
                  <button
                    class="accordion-button text-dark"
                    type="button"
                    data-bs-toggle="collapse"
                    [attr.data-bs-target]="'#collapse' + i"
                    aria-expanded="false"
                    [attr.aria-controls]="'collapse' + i"
                  >
                    {{ survey?.name }}
                  </button>
                </h2>
                <div
                  [attr.id]="'collapse' + i"
                  class="accordion-collapse collapse"
                  data-bs-parent="#accordionExample"
                >
                  <div
                    *ngIf="!survey?.hasDeviceUtilization"
                    class="d-flex justify-content-start my-4 ps-5"
                  >
                    <a
                      [routerLink]="[
                        '/survey/add',
                        selectedApplicationCode,
                        survey?.id
                      ]"
                      class="btn btn-sm btn-primary"
                      >{{ "addNewQuestion" | translate }}</a
                    >
                  </div>
                  <div class="accordion-body">
                    <div
                      *ngIf="
                        !survey?.hasDeviceUtilization;
                        else deviceUtilization
                      "
                    >
                      <div
                        *ngFor="
                          let question of survey?.questions;
                          let isLast = last
                        "
                      >
                        <div
                          class="accordion-wrapper d-flex justify-content-between align-items-start"
                        >
                          <div class="accordion-left">
                            <p class="question-text">
                              {{ question?.text || "-" }}
                            </p>
                            <p class="ps-3">
                              <strong>Answer type: </strong>
                              {{ getAnswerType(question?.answerType || 0) }}
                            </p>
                            <div
                              *ngIf="question?.answerType === 1"
                              class="mb-4 ps-3"
                            >
                              <strong>Options: </strong>
                              <span
                                *ngFor="
                                  let answer of question?.answerOptions;
                                  let lastComma = last
                                "
                              >
                                {{ answer?.answerText }}
                                <span *ngIf="!lastComma">,</span>
                              </span>
                            </div>
                          </div>
                          <div class="accordion-right d-flex">
                            <a
                              [routerLink]="['/survey/edit', question?.id]"
                              class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm cursor-pointer"
                              title="Edit"
                              ><i class="fa-regular fa-pen-to-square"></i
                            ></a>
                            <a
                              (click)="deleteModalId = question?.id || ''"
                              data-bs-toggle="modal"
                              [attr.data-bs-target]="
                                '#questionDeleteModal-' + deleteModalId
                              "
                              title="Delete"
                              class="delete btn btn-icon btn-bg-light btn-active-color-primary btn-sm cursor-pointer"
                              ><i class="fa-regular fa-trash-can"></i
                            ></a>
                          </div>
                        </div>
                        <hr *ngIf="!isLast" class="mt-0" />
                      </div>
                    </div>
                    <ng-template #deviceUtilization>
                      {{
                        "thisSurveyAssociatedWithSugarMeasurement" | translate
                      }}
                    </ng-template>
                  </div>
                </div>
              </div>
            </div>
            <ng-template #noSurvey>
              <div class="pt-4 px-8 text-center">
                <p class="fs-5">
                  {{ "noSurveyToBeDisplayed" | translate }}
                </p>
              </div>
            </ng-template>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Delete Question Modal -->
<div
  class="modal fade"
  [id]="'questionDeleteModal-' + deleteModalId"
  tabindex="-1"
  aria-labelledby="questionDeleteModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-2" id="questionDeleteModalLabel">
          {{ "deleteQuestion" | translate }}
        </h1>
        <button
          type="button"
          class="btn-close cursor-pointer"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body fs-4">
        {{
          "thisActionCannotBeUndoneAreYouSureYouWantToDeleteThisQuestion"
            | translate
        }}
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary cursor-pointer"
          data-bs-dismiss="modal"
        >
          {{ "cancel" | translate }}
        </button>
        <button
          (click)="deleteQuestion(deleteModalId)"
          type="button"
          class="btn btn-danger cursor-pointer"
          data-bs-dismiss="modal"
        >
          {{ "delete" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
